
import Component from "vue-class-component"
import Vue from "vue"
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import {ColumnSeriesDataItem, XYChart} from "@amcharts/amcharts4/charts"
import {Dimension, MemberDimension, MemberSnapshotMeasure} from "@/cube"
import {removeDimensionSortPrefix} from "@/cube/removeDimensionSortPrefix"
import {Prop} from "vue-property-decorator"
import {MetricSliced, MetricStore} from "@/cube/metric-data/MetricStore"

@Component
export default class BarChart extends Vue {
  @Prop()
  metricStore: MetricStore

  @Prop()
  dimension: Dimension

  metricData: MetricSliced<any>

  chart: XYChart

  async created() {
    this.metricData = this.metricStore.getSliced(
      MemberSnapshotMeasure.countMembers,
      [this.dimension, MemberDimension.gender]
    )

    this.$watch(
      () => this.metricData.end,
      () => {
        if (this.metricData.end) {
          console.log(this.metricData.end)
          this.metricData.end.forEach(row => {
            row[this.dimension] = removeDimensionSortPrefix(row[this.dimension])

            row[MemberDimension.gender] = removeDimensionSortPrefix(
              row[MemberDimension.gender]
            )

            const gender = row["Member.gender"]
            if (gender === "Male") {
              row["MemberSnapshot.countMembers"] *= -1
            }
            row[gender] = row["MemberSnapshot.countMembers"]
          })

          this.createChart()
        }
      }
    )
  }

  createChart() {
    this.chart = am4core.create((<any>this.$refs).chart, am4charts.XYChart)
    this.chart.data = this.metricData.end ?? <any>[]

    let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
    categoryAxis.dataFields.category = this.dimension
    categoryAxis.renderer.grid.template.location = 0
    categoryAxis.renderer.inversed = true

    let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
    valueAxis.extraMin = 0.1
    valueAxis.extraMax = 0.1
    valueAxis.renderer.minGridDistance = 40
    valueAxis.renderer.ticks.template.length = 5
    valueAxis.renderer.ticks.template.disabled = false
    valueAxis.renderer.ticks.template.strokeOpacity = 0.4
    valueAxis.renderer.labels.template.adapter.add("text", text => {
      if (text === undefined) {
        return ""
      } else {
        return text === "Male" || text === "Female"
          ? text
          : `${Math.abs(Number(text))}`
      }
    })

    // Create series
    let male = this.chart.series.push(new am4charts.ColumnSeries())
    male.dataFields.valueX = "Male"
    male.dataFields.categoryY = this.dimension
    male.clustered = false

    let maleLabel = male.bullets.push(new am4charts.LabelBullet())
    maleLabel.label.text = "{valueX}"
    maleLabel.label.hideOversized = false
    maleLabel.label.truncate = false
    maleLabel.label.horizontalCenter = "right"
    maleLabel.label.dx = -10

    maleLabel.label.adapter.add("text", (text, target) => {
      if (text === undefined) {
        return ""
      } else {
        return Math.abs(
          (<ColumnSeriesDataItem>target!.dataItem!).valueX
        ).toString()
      }
    })

    let female = this.chart.series.push(new am4charts.ColumnSeries())
    female.dataFields.valueX = "Female"
    female.dataFields.categoryY = this.dimension
    female.clustered = false

    let femaleLabel = female.bullets.push(new am4charts.LabelBullet())
    femaleLabel.label.text = "{valueX}"
    femaleLabel.label.hideOversized = false
    femaleLabel.label.truncate = false
    femaleLabel.label.horizontalCenter = "left"
    femaleLabel.label.dx = 10

    let maleRange = valueAxis.axisRanges.create()
    maleRange.value = -10
    maleRange.endValue = 0
    maleRange.label.text = "Male"
    maleRange.label.fill = this.chart.colors.list[0]
    maleRange.label.dy = 20
    maleRange.label.fontWeight = "600"
    maleRange.grid.strokeOpacity = 1
    maleRange.grid.stroke = male.stroke

    let femaleRange = valueAxis.axisRanges.create()
    femaleRange.value = 0
    femaleRange.endValue = 10
    femaleRange.label.text = "Female"
    femaleRange.label.fill = this.chart.colors.list[1]
    femaleRange.label.dy = 20
    femaleRange.label.fontWeight = "600"
    femaleRange.grid.strokeOpacity = 1
    femaleRange.grid.stroke = female.stroke
  }
}
